import { FC } from 'react'
import { Box, Button, Typography } from '@perk-ui/core'
import { Mail } from 'react-feather'

const ContactSponsorContent: FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="60vh"
      padding={4}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        maxWidth={400}
        textAlign="center"
      >
        <Mail size={48} color="#6B7280" style={{ marginBottom: 24 }} />

        <Typography
          variant="h5"
          style={{
            fontWeight: 700,
            color: '#212121',
            marginBottom: 16,
          }}
        >
          Contact Your Sponsor
        </Typography>

        <Typography
          variant="body1"
          style={{
            color: '#6B7280',
            marginBottom: 32,
            lineHeight: 1.6,
          }}
        >
          This sponsor has reached their provider limit. Please contact your
          sponsor to discuss increasing capacity or availability for new
          providers.
        </Typography>

        <Button
          variant="contained"
          startIcon={<Mail size={16} />}
          style={{
            backgroundColor: '#1B3A52',
            color: '#FFFFFF',
            borderRadius: 8,
            padding: '12px 24px',
            textTransform: 'none',
            fontWeight: 600,
          }}
          onClick={() => {
            // This could be enhanced to open email client or contact form
            window.location.href =
              'mailto:support@databiologics.com?subject=Sponsor Capacity Request'
          }}
        >
          Contact Support
        </Button>
      </Box>
    </Box>
  )
}

export default ContactSponsorContent
